// extracted by mini-css-extract-plugin
export default {"storeBox":"StoreBox_storeBox__72sZY"};